import { Injectable } from '@angular/core';
import { State, Store } from '@ngrx/store';
import { shareReplay } from 'rxjs/operators';

import { Observable } from 'rxjs';
import { AgreementStatuses } from 'src/app/models/agreement-statuses/agreement-statuses';
import { PrivacyPolicyAggregate } from 'src/app/models/privacy-policy/privacy-policy-aggregate';
import { TermsOfServiceAggregate } from 'src/app/models/terms-of-service/terms-of-service-aggregate';
import {
  getAgreementStatuses,
  getPrivacyPolicy,
  getTermsOfService,
} from 'src/app/pages/shared/agreement-statuses/agreement-statuses.reducer';
import { getUnderMaintenance } from './pages/shared/maintenance/maintenance.reducer';

@Injectable()
export class AppQueries {
  readonly underMaintenance$: Observable<boolean>;
  readonly agreementStatuses$: Observable<AgreementStatuses>;
  readonly privacyPolicy$: Observable<PrivacyPolicyAggregate>;
  readonly termsOfService$: Observable<TermsOfServiceAggregate>;

  constructor(private readonly store: Store<State<any>>) {
    this.underMaintenance$ = this.store.pipe(
      getUnderMaintenance,
      shareReplay(1),
    );

    this.agreementStatuses$ = this.store.pipe(
      getAgreementStatuses,
      shareReplay(1),
    );

    this.privacyPolicy$ = this.store.pipe(
      getPrivacyPolicy,
      shareReplay(1),
    );

    this.termsOfService$ = this.store.pipe(
      getTermsOfService,
      shareReplay(1),
    );
  }
}
